import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "39",
  height: "9",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E9778D",
      "fill-rule": "evenodd",
      d: "M6.93 0H5.05a5.18 5.18 0 0 1-2.828 4.522L5.128 8.75H7.49L4.848 4.91A7.02 7.02 0 0 0 6.931 0zM0 8.75h1.943V0H0zM34.077 3.31a3.05 3.05 0 0 0-1.787-.56A3.074 3.074 0 0 0 30.116 8a3.08 3.08 0 0 0 2.174.903c.668 0 1.274-.217 1.787-.56v.404h1.522V2.906h-1.522zM32.43 7.397c-.917 0-1.648-.7-1.648-1.57s.746-1.569 1.648-1.569c.916 0 1.647.7 1.647 1.57.016.87-.73 1.569-1.647 1.569m5.019-.715c-.606 0-1.103.497-1.103 1.103s.497 1.104 1.103 1.104a1.108 1.108 0 0 0 1.02-1.527 1.1 1.1 0 0 0-1.02-.68M26.1 2.75c-.699 0-1.367.217-1.802.808v-.653h-1.756v5.843h1.756V5.547c0-.885.59-1.32 1.321-1.32.761 0 1.212.466 1.212 1.305v3.2h1.756V5.02c0-1.337-1.088-2.27-2.487-2.27zm-10.457.56a3.05 3.05 0 0 0-1.787-.56A3.074 3.074 0 0 0 11.683 8a3.09 3.09 0 0 0 2.174.903c.668 0 1.274-.217 1.787-.56v.404h1.522V2.906h-1.522zm-1.632 4.086c-.917 0-1.647-.7-1.647-1.57s.746-1.569 1.647-1.569c.916 0 1.647.7 1.647 1.57s-.746 1.569-1.647 1.569m5.994-3.698V2.92h-1.757v5.843h1.757v-3.06c0-.886.994-1.274 1.694-1.088h.015V2.921c-.715-.016-1.368.296-1.71.777M8.204 8.749h1.865V0H8.204z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }